import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['noticeTemplate', 'alertTemplate']

  showFlash(event) {
    const { messages } = event.detail

    Object.entries(messages).forEach(([type, message]) => {
      const template = type === 'notice' ? this.noticeTemplateTarget : this.alertTemplateTarget
      this.showMessage(template, message)
    })
  }

  showMessage(template, message) {
    const clonedTemplate = template.content.cloneNode(true)

    clonedTemplate.querySelector('[data-flash-content]').textContent = message

    document.body.appendChild(clonedTemplate)
  }
}
